import React from 'react'

function ExpenseHeadJsx({expense_head, handleExpenseHeadData, expense_data}) {
    return expense_head.map(eh => {
        let data        =   expense_data.length > 0 ? expense_data.find(ed => ed.expense_head_id == eh.id) : null;
        return <>
            <div className="col-sm-4 mt-3">
                <input className="form-control" disabled value={eh.name}/>
                {/* <label htmlFor={field} className="form-label">{eh.name}</label> */}
            </div>
            <div className="col-sm-2 mt-3">
                <input
                    name={eh.key}
                    id={eh.key}
                    type="number"
                    className="form-control text-end"
                    autoComplete="off"
                    value={data ? data.amount : ''}
                    onChange={(e) => {
                        handleExpenseHeadData(eh.id, 'amount', e.target.value)
                    }}
                    placeholder={`Enter Amount`}
                />
            </div>
            <div className="col-sm-6 mt-3">
                <input
                    name={`${eh.key}_note`}
                    type="text"
                    className="form-control"
                    autoComplete="off"
                    value={data ? data.notes : ''}
                    onChange={(e) => {
                        handleExpenseHeadData(eh.id, 'notes', e.target.value)
                    }}
                    placeholder={`Enter ${eh.name} note`}
                />
            </div>
        </>
    })
}

export default ExpenseHeadJsx